<template>
  <div>
    <SectionHeading heading="Partner Status" />
    <Card>
      <div class="grid grid--middle">
        <div
          class="grid__cell"
          :class="
            details.badgeReseller && showFeatured
              ? 'col3-of-12--medium-up'
              : 'col4-of-12--medium-up'
          "
        >
          <Input
            label="Status"
            type="select"
            elId="statusSelect"
            :selected="partner.status"
            :required="true"
            :options="[
              {
                name: 'Public',
                value: 'P',
              },
              {
                name: 'Searchable',
                value: 'S',
              },
              {
                name: 'Hidden',
                value: 'H',
              },
            ]"
            v-on:input-change="handleStatusChange"
          />
        </div>
        <div
          class="grid__cell"
          :class="
            details.badgeReseller
              ? 'col3-of-12--medium-up'
              : 'col4-of-12--medium-up'
          "
          v-if="showFeatured"
        >
          <Input
            label="Featured"
            type="select"
            elId="featuredSelect"
            :selected="featuredSelected"
            :disabled="disableFeatured"
            :required="true"
            :options="[
              {
                name: 'No',
                value: false,
              },
              {
                name: 'Yes',
                value: true,
              },
            ]"
            v-on:input-change="handleFeaturedChange"
          />
        </div>
        <div
          class="grid__cell"
          :class="
            details.badgeReseller && showFeatured
              ? 'col3-of-12--medium-up'
              : 'col4-of-12--medium-up'
          "
        >
          <Input
            label="Tier"
            type="select"
            :placeholder="'Select an option'"
            id="tierSelect"
            :required="true"
            :options="tierOptions"
            :selected="partner.tier"
            v-on:input-change="handleTierChange"
          />
        </div>
        <div
          v-if="details.badgeReseller"
          class="grid__cell"
          :class="
            showFeatured ? 'col3-of-12--medium-up' : 'col4-of-12--medium-up'
          "
        >
          <Input
            label="Badge"
            :placeholder="'Select an option'"
            type="select"
            id="tierSelect"
            :required="true"
            :options="badgeOptions"
            :selected="partner.badge"
            v-on:input-change="handleBadgeChange"
          />
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Input from '@/components/DesignSystem/Input';
import { mapGetters, mapActions } from 'vuex';
const detailPath = 'agencyProfiles/agencyDetail';
import Card from '@/components/DesignSystem/Card';
import SectionHeading from '@/components/DesignSystem/SectionHeading';

export default {
  props: {
    details: Object,
  },
  components: {
    Input,
    Card,
    SectionHeading,
  },
  computed: {
    ...mapGetters({
      partner: `${detailPath}/partner`,
      tiers: 'tiers',
      badges: 'badges',
    }),
    tierOptions() {
      return this.tiers.map(tier => {
        return {
          name: tier.name,
          value: tier.id,
        };
      });
    },
    badgeOptions() {
      return this.badges.map(badge => {
        return {
          name: badge.name,
          value: badge.id,
        };
      });
    },
    featuredSelected() {
      if (this.partner.featured === true) {
        return true;
      } else {
        return false;
      }
    },
    showFeatured() {
      if (this.$store.state.vendorDashboard.details.agenciesFeaturedPartners) {
        return true;
      }
      return false;
    },
    disableFeatured() {
      if (
        this.$store.state.vendorDashboard.agencyProfiles.agencyDetail
          .agencyDetailProfile.partner.status === 'H'
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      handleStatusChange: `${detailPath}/agencyDetailProfile/handleStatusChange`,
      handleFeaturedChange: `${detailPath}/agencyDetailProfile/handleFeaturedChange`,
      handleTierChange: `${detailPath}/agencyDetailProfile/handleTierChange`,
      removeProfile: `${detailPath}/agencyDetailProfile/removeProfile`,
      handleBadgeChange: `${detailPath}/agencyDetailProfile/handleBadgeChange`,
    }),
    activeBadge(badgeValue) {
      return this.partner.badge === badgeValue;
    },
    handleEditChange(e) {
      /* eslint-disable-next-line */
      console.log(e.value);
    },
  },
};
</script>
